import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Route, Switch, Redirect } from 'react-router-dom';
import homeRoutes from '../routes/homeRoutes';

const styles = theme => ({
  toolbar: theme.mixins.toolbar,
  root: {
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    backgroundColor: '#f1f8e9',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100%',
  },
});

const Main = props => {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Switch>
          {homeRoutes.map(route => (
            <Route
              key={route.key}
              path={route.path}
              exact={route.exact}
              component={route.component}
            />
          ))}
          <Redirect from="/home" to="/home/listings" />
        </Switch>
      </main>
    </div>
  );
};

export default withStyles(styles)(Main);



// WEBPACK FOOTER //
// ./src/components/Main.js